import type { ColumnType } from 'antd/lib/table';
import { TFunction } from 'i18next';

export const lunchesCountColumn = <T extends { lunchesCount: number }>(
  t: TFunction,
): ColumnType<T> => ({
    title: t('Lunches count'),
    dataIndex: 'lunchesCount',
  });
